module.exports = __webpack_public_path__ + "static/media/paint-bucket.a5df8fc6.svg";